import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../../../../v2/components/ui/loadArtemisFonts';
import Typography from '../../../../v2/style-helper/Typography';

export default createUseStyles({
  heading: {
    textAlign: 'center',
    fontSize: 21,
    lineHeight: '21px',
    marginBottom: 21,
    fontWeight: 'normal',
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.large1])
      && loadArtemisFonts(props.theme.typography[Typography.large1], true),
    }),
  },
  subheading: {
    fontSize: 16,
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.body])
      && loadArtemisFonts(props.theme.typography[Typography.body]),
    }),
  },
  referralCode: {
    color: props => props.theme.completePage.referralCodeFontColor,
    fontWeight: 700,
    backgroundColor: '#eee',
    padding: '0.4em 2.8em',
    margin: '1.5em 0',
    borderRadius: props => props.theme.completePage.referralCodeBorderRadius,
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.small])
      && loadArtemisFonts(props.theme.typography[Typography.small], true),
    }),
  },
  explanation: {
    marginBottom: '1em',
  },
});
